import { createContext } from 'react'

import { TSessionDetails, TSignoutContext } from '~/features/auth/models'

export const SignoutContext = createContext<TSignoutContext | null>(null)

export const EMPTY_SESSION: TSessionDetails = {
  groups: [],
  email: '',
  cognitoUid: '',
  accessToken: '',
}
